import { render, staticRenderFns } from "./Block1Item.vue?vue&type=template&id=d167071c&scoped=true&"
import script from "./Block1Item.vue?vue&type=script&lang=js&"
export * from "./Block1Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d167071c",
  null
  
)

export default component.exports